<template>
  <div class="bg-full-screen-image login-page">
    <div class="app-content content">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header row">
        </div>
        <div class="content-body">
          <section class="row flexbox-container">
            <div class="col-xl-8 col-11 d-flex justify-content-center">
              <div class="card bg-authentication rounded-0 mb-0">
                <div class="row m-0">
                  <div class="col-lg-6 d-lg-block d-none text-center align-self-center px-1 py-0">
                    <img src="img/logo.svg" alt="" class="mb-1">
                    <br>
                    <img src="img/login.png" alt="branding logo">
                  </div>
                  <div class="col-lg-6 col-12 p-0 ">
                    <div class="card rounded-0 mb-0 py-3 px-2 position-relative" v-bind:class="{ 'py-5': !checked}">
                      <select @change="changeLang" v-model="user_lang"
                              class="form-control position-absolute lang-select">
                        <option value="uk">UA</option>
                        <option value="en">EN</option>
                        <option value="ru">ru</option>
                      </select>
                      <div class="card-header pb-1">
                        <div class="card-title ">
                          <h4 class="mb-0">{{ lexicon.drop_auth_title }}</h4>

                        </div>
                      </div>
                      <p class="px-2">{{ lexicon.drop_auth_welcome }}</p>
                      <div class="card-content">
                        <div class="card-body pt-1">
                          <template v-if="!checked">
                            <form @submit.prevent="check('check')">
                              <fieldset
                                  class="form-label-group form-group position-relative has-icon-left">
                                <input v-model="form.phone"
                                       v-bind:class="{ error: error.username}"
                                       type="tel" class="form-control" id="user-name"
                                       :placeholder="lexicon.drop_phone_or_email" required>
                                <div class="form-control-position">
                                  <i class="feather icon-phone"></i>&nbsp;<i class="feather icon-mail"></i>
                                </div>
                                <label for="user-name">{{ lexicon.drop_phone_or_email }}</label>
                              </fieldset>
                              <button type="submit" :disabled="!!loading"
                                      class="btn btn-primary btn-block">
                                {{ lexicon.drop_sign_in }}
                              </button>
                            </form>
                          </template>

                          <template v-else>
                            <form @submit.prevent="submit"
                                  v-bind:class="{ 'd-none': !checked}">
                              <fieldset
                                  class="form-label-group form-group position-relative has-icon-left">
                                <input v-model="form.phone"
                                       v-bind:class="{ error: error.username}"
                                       type="tel" class="form-control" id="user-phone"
                                       :placeholder="lexicon.drop_phone_or_email" required>
                                <div class="form-control-position">
                                  <i class="feather icon-phone" v-if="!form.is_email"></i>
                                  <i class="feather icon-mail" v-if="form.is_email"></i>
                                </div>
                                <label for="user-phone">{{ lexicon.drop_phone_or_email }}</label>
                              </fieldset>
                              <fieldset
                                  class="form-label-group form-group position-relative has-icon-left">
                                <input v-model="form.password" ref="password"
                                       v-bind:class="{ error: error.password}"
                                       :type="type" class="form-control"
                                       id="user-password"
                                       :placeholder="title" required>
                                <div class="form-control-position">
                                  <i class="feather icon-lock"></i>
                                </div>
                                <label for="user-password">{{ title }}</label>
                              </fieldset>

                              <button type="submit" :disabled="!!loading"
                                      class="btn btn-primary btn-block">
                                {{ lexicon.drop_sign_in }}
                              </button>

                            </form>
                            <div :class="alertType">{{ alertText }}</div>
                            <div v-if="(error_count > 2)">
                              <button type="button" @click="resetPass"
                                      class="btn btn-outline-success btn-block mt-2 ">
                                {{ lexicon.drop_get_new_pass }}
                              </button>
                            </div>
                          </template>
                        </div>
                      </div>
                      <div class="login-footer">

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {mapActions, mapState} from 'vuex'
import toast from "../helpers/toast";

export default {
  name: 'login',
  components: {},
  data() {
    return {
      form: {
        phone: '',
        is_email: false,
        password: '',
      },
      error: {},
      error_count: 0,
      loading: false,
      user_lang: 'uk',
      checked: false,
      title: 'СМС пароль',
      type: 'text',
      alert: false,
      alertText: '',
      alertType: 'werwerwer efwrwer er wer',
    }
  },
  computed: mapState({
    lexicon: state => state.lexicon,
    lang: state => state.lang,
  }),
  mounted() {

    this.user_lang = this.lang
    if (location.hostname === 'drop.brushme.com') {
      this.user_lang = 'en'
      this.changeLang()
    }
  },
  methods: {
    ...mapActions({
      Login: 'auth/Login',
      Check: 'auth/Check',
      getLexicon: 'getLexicon',
    }),
    submit() {
      this.error = {}
      if (this.type == 'text' && this.form.password.match(/^\d{4}$/)) {
        this.form.password = [this.form.password.slice(0, 2), this.form.password.slice(2)].join('-')
      }
      if ((this.type != 'text') || this.form.password.match(/^\d{2}-\d{2}$/) || this.form.password.match(/^\d{4}$/) || this.form.password.match(/^\d{6}$/)) {
        this.loading = true
        this.Login(this.form).then(() => {
          this.$router.replace({
            'name': 'home'
          })
          this.loading = false
        }).catch((data) => {
          if (data.data.input) {
            this.error = data.data.input
            this.loading = false
          }
          if (this.type === 'password') {
            this.error_count++;
          }
        })
      } else {
        this.error.password = 1;
        toast.error(this.lexicon.drop_enter_correct_pass)

      }
    },
    check(type) {
      this.loading = true
      this.error = {}

      let login_key = 'phone';
      if (this.form.phone.indexOf('@') < 0) {
        this.form.phone = this.form.phone.replace(/[^0-9]/g, "")
      } else {
        login_key = 'email';
      }

      this.Check({[login_key]: this.form.phone, 'type': type}).then((data) => {
        this.type = data.data.type
        this.form.is_email = data.data.is_email
        this.title = data.data.title
        if (data.data.alert) {
          this.alertType = data.data.alertType;
          this.alertText = data.data.alertText;
        }
        this.loading = false
        this.checked = true
        this.$nextTick(() => {
          this.$refs.password.focus()
        })
      }).catch((data) => {
        if (data.data.input) {
          this.error = data.data.input
          this.loading = false
        }
      })
    },
    resetPass() {
      this.error_count = 0
      this.form.password = ''
      this.type = 'text'
      this.check('sms')
    },
    changeLang() {
      localStorage.setItem('user_lang', this.user_lang)
      this.getLexicon();
    }
  }
}
</script>
<style>
.lang-select {
  width: 70px !important;
  right: 5px;
  top: 5px;
}
</style>